import React from "react";
import "./App.scss";
import { HashRouter } from "react-router-dom";
import RouterContainer from "./components/RouterContainer";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import NiceModal from '@ebay/nice-modal-react';
import ReactGA from 'react-ga4';
import ScormCDNTest from "components/ScormCDNTest"; 
// import { ModalProvider } from "react-simple-modal-provider";
// import modals from "pctComponents/modals";


function App() {
  const host_location = window.location.hostname;
  const trackindIds = {
    "default": "G-53FQ2SMF6Z",
    "educacao.totvs.com": "G-JM1BTQMMCG",
    "afferolabhub.peoplecraft.com.br": "G-FV6C00Q2CN",
    "totvs.peoplecraft.com.br": "G-3VRQ7BSNGD",
  }

  const TRACKING_ID = trackindIds[host_location] ? trackindIds[host_location] : trackindIds['default'];

  ReactGA.initialize(TRACKING_ID);

  return (
    <HashRouter>
      <div className="App" translate="no">
        <NiceModal.Provider>
          <RouterContainer />
          <ToastContainer />
          <ScormCDNTest />
        </NiceModal.Provider>
      </div>
    </HashRouter>
  );
}

export default App;
